import { Utils } from 'mptcfe-utils'

 export default {
    /**
     * @description 裁剪图片
     * @param {*} picUrl 图片源地址
     * @param {*} picWidth 裁剪目标宽度
     * @param {*} picHeight 裁剪目标高度
     * @returns {string} 裁剪后的图片地址
     */
    setPicSize: Utils.setPicSize || new Function(),
    // 视频播放器的图片裁剪
    setVideoPicUtil (opt) {
        let innerWidth = window.innerWidth,
            w = opt.width,
            h = opt.height,
            conversionHeight = h*(innerWidth/w),
            conversionWidth = window.innerWidth,
            maxHeight = (opt.maxHeight || 800);
            // 最大高度限制
            conversionHeight > maxHeight && (conversionHeight = maxHeight);

        let cover = this.setPicSize(opt.cover && opt.cover.replace(/.com\/([^\/]*,[^\/]*\/){0,1}/, '.com/'), conversionWidth, conversionHeight, opt.mode || 'c_lfill');

        let params = {
            width: conversionWidth,
            height: conversionHeight,
            cover,
        }

        return params;
    }
}